import React from "react";
import PropTypes from "prop-types";

export function BlobLink({ children, to }) {
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={URL.createObjectURL(new Blob([to], { type: "text/html" }))}
    >
      {children}
    </a>
  );
}

BlobLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node,
};

BlobLink.defaultProps = { children: undefined };

export default BlobLink;
